export default __webpack_public_path__ + "a86213929c2bd6dc53c4182bfb2f06e9.svg";